import { Component, OnInit } from '@angular/core';

import { LoginService } from '../../../login-service';
import Swal from 'sweetalert2';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss'],
  providers:[LoginService]
})
export class CmsComponent implements OnInit {
  public Editor = ClassicEditor;

  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  
  currentpage: number=1;
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  cmsList:any;
  type:string;
  addCMS:boolean=false;
  PageName:string;
  Type:string;
  PageContent:string;

  menuData:any;
  searchText: any;
  rolesList: any;
  MenuPermissions: any;
  userID:string;
  menuName: any;
  menuID: any;
  roleID: string;
  pageID: any;
  message: string;
  cmsListdetails:any;
  adminUserType:string;
  selectedcmsListid=[]
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p:any;
  count:any;
savefilter: any;
  constructor(private logins:LoginService) { 
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
  
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    
    this.adminUserType=localStorage.getItem("userTypeid");
    this.GetMenusByUserType(3);
  }

  ngOnInit(): void {
    this.logins.getselectpage(10)
    this.GetRoles();
    this.GetCMS();
  }
  GetRoles(){
    this.logins.GetRoles(this.adminUserType).subscribe(data=>
      {  
              this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
  let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

  if(filteRole.length>0){
    this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
    
  }
  });
  }
  GetMenusByUserType(userTypeID){
    this.logins.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    
    this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
   
    let tempdata=this.menuData;
    
    if(tempdata.length>0){
    this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='cms');
    
    if(this.menuData.length>0)
      {
    this.menuName=this.menuData[0]["menu_name"];
    this.menuID=this.menuData[0]["menu_id"];
      }
    

    }
    
        });
        }

  GetCMS(){
    this.logins.Getcms(this.adminUserType).subscribe(data=>{
      this.cmsList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));

      this.cmsListdetails=this.cmsList;
      this.savefilter=this.cmsListdetails
      this.assigndynamicarray(this.cmsList)
      if(this.cmsListdetails.length>0){
        this.setPage(1);
      }
      
});

  }
  assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}
  changepagination(page:number){
    this.count=this.rowsOnPage
    console.log(this.rowsOnPage)
    this.logins.getselectpage(this.rowsOnPage)
    this.logins.getPager(this.cmsListdetails.length, page);
    this.setPage(page)
  }
  setPage(page: number) {

   this.p=page;
    this.pager = this.logins.getPager(this.cmsListdetails.length, page);
    this.count=this.pager.pageSize
    this.pagedItems = this.cmsListdetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.cmsList = this.cmsListdetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  
}
  Searchtext(){
    this.cmsList = this.savefilter;
    
        let tempCompany = this.cmsList.filter(
          (item) => {
            return (
              (item.pagename !== null && item.pagename.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
              (item.Type !== null && item.Type.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
              
            );
          }
    
        );
        this.cmsList = tempCompany;
        this.assigndynamicarray(tempCompany)
    // if(this.searchText==""){
    //   this.GetCMS();
    //   this.assigndynamicarray(this.cmsList)
    // }
    if(this.searchText !== ""){
      this.cmsListdetails = tempCompany;
      this.setPage(1);
  }else{
      this.cmsListdetails = this.savefilter;      
      this.assigndynamicarray(this.cmsList)

      this.setPage(1);
  }
     
  }
  cancelCMS(){
this.addCMS=false;
  }
  AddCMS(){
    this.addCMS=true;
    this.type="New";
  }
  saveCMS(){
    const json={
      pageid:this.pageID,
      pagename:this.PageName,
     type:this.Type,
     pagecontent:this.PageContent,
     createdbyparm:'Admin',
     updatedbyparm:"Admin"
    };
  
     if(this.PageName==" "|| this.PageName==undefined){
      return;
    }
    
    
    this.logins.SaveCMS(json).subscribe((dataJson) => {
    
     if (dataJson['_body'].toString() === 'true') {
      
      if(this.type== "New"){
        // Swal.fire("Saved Successfully");
        this.logins.showSuccess("Saved Successfully","");
        
        setTimeout(() => {
          this.message = "";
        }, 5000);
        }
        else if(this.type==="Edit"){
         
          this.logins.showSuccess("Updated Successfully","");
          // Swal.fire("Updated Successfully");
          this.addCMS=false;
        }
     this.GetCMS();
     //this.setPage(1);
     if(this.type==="New"){
       this.PageName="";
       this.pageID="";
       this.PageContent="";
       this.Type="";
     }
   }
  this.GetCMS();
     });
    
    
  } 
   editCMS(row){
    this.addCMS=true;
  this.pageID=row.id;
  this.PageName=row.pagename;
  this.PageContent=row.pagecontent;
  this.Type=row.Type;
  this.type="Edit";
  }
  selectRow(id,e){
    if(e.target.checked){
     this.selectedcmsListid.push(e.target.id)
    }
    else{
     var index = this.selectedcmsListid.indexOf(e.target.id);
    this.selectedcmsListid.splice(index,1)
    }
  }
  DeleteSelected(){
   if(this.selectedcmsListid.length==0){
     return;
   }
   else{
     event.stopPropagation();
     Swal.fire({
       title: 'Are you sure?',
       text: 'You want to delete the selected rows' ,///
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Yes',
       cancelButtonText: 'No'
     }).then((result) => {
       if (result.value) {
         this.deleterows(this.selectedcmsListid);//
       } else if (result.dismiss === Swal.DismissReason.cancel) {
   
       }
     })
   }
  }
  deleterows(list){
 for(var i=0;i<list.length;i++){
   this.delete(list[i],'d');
   this.selectedcmsListid=[];
 }
  }
  deleteCMS(row,isactive,text){
   
      event.stopPropagation();
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to '+text+' this cms:' + row.pagename,///
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.delete(row.id,isactive);//
        } else if (result.dismiss === Swal.DismissReason.cancel) {
    
        }
      })
    
    }
    
    delete(ID,isactive) {
    
      this.logins.DeleteCMS(ID,isactive).subscribe(data => {
        
        if(isactive=='d'){
          this.logins.showSuccess("Deleted Successfully","");

        }
       else if(isactive=='y'){
        this.logins.showSuccess("Activated Successfully","");

       }
       else{
        this.logins.showSuccess("Deactivated Successfully","");

       }
        //this.setPage(currentpage);
        this.GetCMS();
        setTimeout(() => {
          this.message = "";
        }, 1000);
      // this.getFares();
      // this.setPage(1);
      })
    }

    
    
}
